import React from 'react'
import Payment from './Payment';
import { PaymentType } from './PaymentType';
import { FattPayBank } from './FattPayBank';
import { CardXCreditCard } from './CardXCreditCard';
import { FattPayCreditCard } from './FattPayCreditCard';
import { CreditCardClientLibrary } from './PaymentProcessor';

interface IPaymentTypeSelectorProps {
    creditCardProcessor : CreditCardClientLibrary;
    onPaymentChanged: (payment: Payment) => void;
    isDisabled : boolean;
    payment: Payment,
}

export const PaymentTypeSelector = React.forwardRef((props: IPaymentTypeSelectorProps, ref: React.Ref<any>) => {
    return <React.Fragment>
        {props.payment.paymentType === PaymentType.CreditCardVisa && <CreditCardPaymentTypeSelector creditCardProcessor={props.creditCardProcessor} isDisabled={props.isDisabled} payment={props.payment} onPaymentChanged={props.onPaymentChanged}/>}
        {props.payment.paymentType === PaymentType.ECheckAch && <FattPayBank ref={ref} disabled={props.isDisabled} payment={props.payment} onPaymentChanged={props.onPaymentChanged} />}
    </React.Fragment>
});

const CreditCardPaymentTypeSelector = React.forwardRef((props: IPaymentTypeSelectorProps) : React.ReactElement => {
    switch (props.creditCardProcessor){
        case CreditCardClientLibrary.CardX:
            return <CardXCreditCard isDisabled={props.isDisabled} showPaymentButton={props.payment.paymentType === PaymentType.CreditCardVisa} payment={props.payment} onPaymentChanged={props.onPaymentChanged}/>;
        case CreditCardClientLibrary.FattPay:
            return <FattPayCreditCard onPaymentChanged={props.onPaymentChanged} payment={props.payment} disabled={props.isDisabled}/>
        default:
        case CreditCardClientLibrary.None:
            return null;
    }
});
